import Actions from "../../actions";
import * as requestFromServer from "./organizationSponsorshipApis";

export const getOrganizationTopListingSubscriptionPlanAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getOrganizationTopListingSubscriptionPlan(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_ORGANIZATION_SPONSORSHIP_LIST,{organizationSponsorships:response}))
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

export const createOrganizationSponsorshipAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createOrganizationSponsorship(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

export const updateOrganizationSponsorshipAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateOrganizationSponsorship(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

export const getOrganizationSponsorshipByIdAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getOrganizationSponsorshipById(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

